import {
  DEFAULT_KEYWORD_BG_COLOR,
  DEFAULT_KEYWORD_LINE_COLOR,
} from '@/common/components/molecules/keywordSettingModal/keywordSettingModal.define';
import {
  AddedKeyword,
  FilteredKeyword,
  Keyword,
} from '@/common/components/molecules/keywordSettingModal/keywordSettingModal.types';

export const wrapText = (text: string, keyword: Keyword) =>
  `<mark class="log-highlight-keyword" style="--keyword-bg-color: ${
    keyword.bgColor
  }; --keyword-line-color: ${keyword.lineColor ?? 'transparent'};">${text}</mark>`;

export const highlightLog = (
  log: string,
  {
    configKeywordList,
    userKeywordList,
  }: { configKeywordList?: FilteredKeyword[]; userKeywordList?: AddedKeyword[] },
) => {
  /**
   * 같은 keyword라면, configKeywordList가 우선순위를 가짐
   */
  const keywords = [...(configKeywordList ?? []), ...(userKeywordList ?? [])].filter(
    (item) => item.keyword && ['string', 'regexp'].includes(item.type),
  );
  const result: string[] = [];

  let matchedInfo = {
    length: 0,
    keyword: {} as Keyword,
  };

  let substring = log;
  let pos = 0;

  while (pos < substring.length) {
    substring = substring.slice(pos + matchedInfo.length);
    matchedInfo = { length: 0, keyword: {} as Keyword };
    pos = substring.length;

    keywords.forEach((keyword) => {
      try {
        const flags = keyword.type === 'regexp' ? '' : 'i';

        const regExp =
          keyword.type === 'string'
            ? new RegExp(keyword.keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), flags)
            : new RegExp(keyword.keyword, flags);

        const match = regExp.exec(substring);
        if (!match || match[0].length === 0) return;
        if (match.index < pos || (pos === match.index && match[0].length > matchedInfo.length)) {
          pos = match.index;
          matchedInfo = {
            length: match[0].length,
            keyword,
          };
        }
      } catch (error) {
        if (error instanceof SyntaxError && error.message.includes('Invalid regular expression')) {
          console.warn(
            'Invalid regular expression, PCRE is not supported on this browser',
            keyword.keyword,
          );
        }
      }
    });

    if (pos >= substring.length || matchedInfo.length === 0) {
      result.push(substring);
      break;
    }

    result.push(substring.slice(0, pos));
    result.push(wrapText(substring.slice(pos, pos + matchedInfo.length), matchedInfo.keyword));
  }

  return result.join('');
};

export const getFilteredKeysHighlightInfo = (
  filteredKeys: string[],
  highlightInfo: FilteredKeyword[] = [],
): FilteredKeyword[] =>
  filteredKeys?.map((name) => {
    const keywordItem = highlightInfo?.find((keyword) => keyword.keyword === name);

    if (keywordItem) {
      return keywordItem;
    }

    return {
      keyword: name ?? '',
      type: 'string' as const,
      lineColor: DEFAULT_KEYWORD_LINE_COLOR,
      bgColor: DEFAULT_KEYWORD_BG_COLOR,
    };
  }) ?? [];

export const getAddedKeysHighlightInfo = (logContent: string, highlightInfo: AddedKeyword[] = []) =>
  highlightInfo?.filter((keyword) => new RegExp(keyword.keyword, 'i').test(logContent));
